module.exports = "img {\n  width: 100%;\n  height: 500px; }\n"


//////////////////
// WEBPACK FOOTER
// ./Frontend/src/app/components/home/home-carousel/home-carousel.component.scss
// module id = ./Frontend/src/app/components/home/home-carousel/home-carousel.component.scss
// module chunks = main